<template>
  <!-- 申请列表页 -->
  <div class="apply-list">
    <a-card style="margin-bottom: 10px">
      <search-view
        :renderItem="SEARCH_SCHEMA"
        :isExpandShowOrNot="false"
        :initialValues="initSearchForm"
        @fetchSearch="handleSearch"
      ></search-view>
    </a-card>
    <a-card>
      <div class="text-right">
        <a-button @click="exportTable" type="primary">导出</a-button>
      </div>
      <table-view
        bordered
        :data="tableData"
        :columns="columns"
        :pagination="pageData"
        :loading="tableLoading"
        :scroll="SCROLL"
        @handlePagination="handlePagination"
      >
        <!-- <template v-slot:applyAmount="{ tableRow }">
          <span v-html="$formatAppAmount(tableRow.applyAmount)"></span>
        </template> -->
        <!-- <template v-slot:approveAmount="{ tableRow }">
          <span v-html="$formatAppAmount(tableRow.approveAmount)"></span>
        </template> -->

        <template v-slot:type="{ tableRow }">
          <span>{{ CREDIT_TYPE_OBJ[tableRow.type] }}</span>
        </template>

        <template v-slot:status="{ tableRow }">
          <a-tag
            :color="APPROVAL_STATUS_OBJ[tableRow.status].color"
            style="width: 70px; text-align: center;"
          >
            {{ APPROVAL_STATUS_OBJ[tableRow.status].label }}
          </a-tag>
        </template>

        <template v-slot:action="{ tableRow }">
          <a-button type="link" size="small" @click="handleView(tableRow)">
            查看
          </a-button>
          <template v-if="tableRow.status === 1">
            <a-divider type="vertical" />
            <a-popconfirm
              title="确认撤销？"
              ok-text="确定"
              cancel-text="取消"
              @confirm="handleRevoke(tableRow)"
              @cancel="handleCancel"
            >
              <a-icon slot="icon" type="question-circle-o" class="icon-color" />
              <a-button type="link" size="small">
                撤销
              </a-button>
            </a-popconfirm>
          </template>
        </template>
      </table-view>
    </a-card>
  </div>
</template>

<script>
import { SearchView, TableView } from 'lxfintech-fe'
import cloneDeep from 'lodash/cloneDeep'
import { SEARCH_SCHEMA } from '../schema'
import { cancelExtension, exportExtensionList } from '../api'
import { getExtensionList } from '../../api'
import { formatParamDate } from 'utils/util'
import { CREDIT_TYPE_OBJ, APPROVAL_STATUS_OBJ } from '../../const'

export default {
  name: 'extension-list',
  data() {
    const initSearchForm = {
      companyName: '',
      companyCode: '',
      endTime: '',
      startTime: '',
      id: '',
      status: '',
    }
    const searchForm = cloneDeep(initSearchForm)
    return {
      SEARCH_SCHEMA,
      CREDIT_TYPE_OBJ,
      APPROVAL_STATUS_OBJ,
      tableLoading: false,
      initSearchForm,
      searchForm,
      tableData: [],
      columns: [
        {
          title: '序号',
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
          width: 80,
          fixed: 'left',
          align: 'center',
        },
        {
          title: '申请流水号',
          dataIndex: 'id',
          align: 'center',
          width: 150,
        },
        {
          title: '申请人',
          dataIndex: 'applier',
          width: 150,
        },
        {
          title: '申请日期',
          dataIndex: 'applyDate',
          align: 'center',
          width: 170,
        },
        {
          title: '企业名称',
          dataIndex: 'companyName',
          width: 250,
        },
        {
          title: '企业编码',
          dataIndex: 'companyCode',
          width: 150,
        },
        // {
        //   title: '专项凭证号',
        //   customRender: (text, record) => {
        //     return record.specialNo.join(', ')
        //   },
        //   width: 150,
        // },
        // {
        //   title: 'Financialtransaction',
        //   customRender: (text, record) => {
        //     return record.numNo.join(', ')
        //   },
        //   width: 160,
        // },
        {
          title: '原到期日',
          dataIndex: 'oldIndateEnd',
          align: 'center',
          width: 130,
        },
        {
          title: '申请延期至',
          dataIndex: 'newIndateEnd',
          align: 'center',
          width: 130,
        },
        {
          title: '信用类型',
          scopedSlots: { customRender: 'type' },
          align: 'center',
          width: 150,
        },
        // {
        //   title: '大区/区域',
        //   dataIndex: 'region',
        //   width: 150,
        // },
        {
          title: '审批角色',
          dataIndex: 'approveRole',
          width: 150,
        },
        {
          title: '状态',
          scopedSlots: { customRender: 'status' },
          align: 'center',
          width: 120,
        },
        {
          title: '审批日期',
          dataIndex: 'approveDate',
          align: 'center',
          width: 170,
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'action' },
          width: 140,
          fixed: 'right',
        },
      ],
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      SCROLL: { x: 1950 },
    }
  },
  mounted() {
    this._getExtensionList(this.initSearchForm)
  },
  methods: {
    // 点击查询按钮
    handleSearch(data) {
      data = formatParamDate(data, data.applyRangeDate)
      delete data.applyRangeDate
      this.searchForm = data
      this.pageData.current = 1 // 设置为第一页
      this._getExtensionList(data)
    },
    async _getExtensionList(searchForm) {
      if (this.tableLoading) {
        return
      }
      this.tableLoading = true
      const { current, pageSize } = this.pageData
      const formData = {
        ...searchForm,
        size: pageSize,
        current,
      }
      try {
        const {
          data: { total, records },
        } = await getExtensionList(formData)
        this.pageData.total = total
        this.tableData = records
        this.tableLoading = false
      } catch (error) {
        console.error(error)
      }
    },
    handlePagination(pagination) {
      ;({
        current: this.pageData.current,
        pageSize: this.pageData.pageSize,
        total: this.pageData.total,
      } = pagination)
      this._getExtensionList(this.searchForm)
    },
    handleView(row) {
      const { id, type, status } = row
      this.$router.push({
        path: `/credit-approval/limit/apply-detail/${id}`,
        query: {
          type,
          status,
        },
      })
    },
    async handleRevoke(row) {
      const id = row.id
      try {
        const { data } = await cancelExtension(id)
        if (data) {
          this._getExtensionList(this.searchForm)
        }
      } catch (error) {
        console.error(error)
      }
    },
    handleCancel() {
      this.$message.info('已取消撤销')
    },

    exportTable() {
      const params = {
        ...this.searchForm,
      }
      exportExtensionList(params)
    },
  },
  components: {
    SearchView,
    TableView,
  },
}
</script>

<style></style>
